import { SvgIcon, SvgIconProps } from '@mui/material';

interface Props extends SvgIconProps {
  /** @default 'outlined' */
  variant?: 'outlined' | 'filled';
}

const PaperPlaneIcon = ({ variant = 'outlined', ...props }: Props) => {
  if (variant === 'filled') {
    return (
      <SvgIcon
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M21 4.00001C20.9896 3.90814 20.9695 3.81764 20.94 3.73001V3.64001C20.8921 3.52872 20.8243 3.42706 20.74 3.34001C20.6552 3.26027 20.557 3.19597 20.45 3.15001H20.36C20.2679 3.07962 20.1624 3.02859 20.05 3.00001H20C19.9006 2.98492 19.7995 2.98492 19.7 3.00001L1.70002 9.00001C1.49995 9.06577 1.32575 9.19301 1.20225 9.3636C1.07876 9.53419 1.01227 9.73941 1.01227 9.95001C1.01227 10.1606 1.07876 10.3658 1.20225 10.5364C1.32575 10.707 1.49995 10.8342 1.70002 10.9L10.23 13.74L13.07 22.27C13.1358 22.4701 13.263 22.6443 13.4336 22.7678C13.6042 22.8913 13.8094 22.9578 14.02 22.9578C14.2306 22.9578 14.4358 22.8913 14.6064 22.7678C14.777 22.6443 14.9043 22.4701 14.97 22.27L20.97 4.27001C20.9923 4.18179 21.0023 4.09095 21 4.00001ZM16.3 6.29001L10.73 11.86L5.16002 10L16.3 6.29001ZM14 18.84L12.14 13.27L17.71 7.70001L14 18.84Z"
          fill="currentColor"
        />
      </SvgIcon>
    );
  }

  return (
    <SvgIcon
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 4.00001C20.9896 3.90814 20.9695 3.81764 20.94 3.73001V3.64001C20.892 3.52872 20.8243 3.42706 20.74 3.34001C20.6551 3.26027 20.557 3.19597 20.45 3.15001H20.36C20.2678 3.07962 20.1624 3.02859 20.05 3.00001H20C19.9006 2.98492 19.7994 2.98492 19.7 3.00001L1.69999 9.00001C1.49992 9.06577 1.32572 9.19301 1.20222 9.3636C1.07873 9.53419 1.01224 9.73941 1.01224 9.95001C1.01224 10.1606 1.07873 10.3658 1.20222 10.5364C1.32572 10.707 1.49992 10.8342 1.69999 10.9L10.23 13.74L13.07 22.27C13.1357 22.4701 13.263 22.6443 13.4336 22.7678C13.6042 22.8913 13.8094 22.9578 14.02 22.9578C14.2306 22.9578 14.4358 22.8913 14.6064 22.7678C14.777 22.6443 14.9042 22.4701 14.97 22.27L20.97 4.27001C20.9922 4.18179 21.0023 4.09095 21 4.00001ZM16.3 6.29001L10.73 11.86L5.15999 10L16.3 6.29001ZM14 18.84L12.14 13.27L17.71 7.70001L14 18.84Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default PaperPlaneIcon;
